import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import { reviews } from './reviewsData';
import Quote from './blockquote.svg';
import './testimonial.css'

const Testimonials = () => {
	return (
		<section className="testimonial-container">
			<div className="section-title">
				<h5 className="title-sub">our work</h5>
				<h2 className="title-1">What people say</h2>
			</div>

			<div className="slider-container-t">
				{/* <blockquote>
					<img className="top-quote quote" src={Quote} alt="quote" />
					<img className="bottom-quote quote" src={Quote} alt="quote" />
				</blockquote> */}

				<Splide
					options={{
						perPage: 1,
						autoplay: true,
						speed: 1000,
						rewind: true,
						rewindByDrag: true,
					}}
				>
					{reviews.map((review) => (
						<SplideSlide key={review.id}>
							{/* <img className="review-img" src={review.image} alt="" /> */}
							{/* <div className="content">
								<p className="text">{review.text}</p>
								<div className="content1">
									<h2>{review.name}</h2>
								</div>
							</div> */}
							<div className="testcont">
								<p>{review.text}</p>
								<h4>{review.name}</h4>
							</div>
						</SplideSlide>
					))}
				</Splide>
			</div>
		</section>
	);
};

export default Testimonials;
